module.exports = __webpack_public_path__ + "img/vuesax-login-bg2.7ef2ce27.jpg";